// ================================================================
// 管理員路由保護組件
// ================================================================
// 版本：1.0
// 日期：2026-01-21
// 功能：保護管理員專屬頁面
// ================================================================

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import { useAdmin } from '../../contexts/AdminContext';

interface AdminRouteProps {
  children: React.ReactNode;
  requiredRoles?: string[];
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children, requiredRoles }) => {
  const { isAdminAuthenticated, isLoading, admin } = useAdmin();
  const location = useLocation();

  // 載入中顯示 loading
  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  // 未登入，導向管理員登入頁
  if (!isAdminAuthenticated) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  // 如果有指定權限角色，檢查角色
  if (requiredRoles && requiredRoles.length > 0 && admin) {
    if (!requiredRoles.includes(admin.role)) {
      // 權限不足，導向管理員首頁
      return <Navigate to="/admin/dashboard" replace />;
    }
  }

  return <>{children}</>;
};

export default AdminRoute;
